import { Flex } from "antd";
import copanLogo from "../../assets/logo_copan.webp";

import "./authContainer.css";

const Logo = () => {
    return (
        <div className='center'>
            <img
                className='auth-container-logo'
                src={copanLogo}
                alt='logo copan'
                width={150}
                height={78}
            />
        </div>
    );
};
const AuthContainer = ({ children }) => {
    return (
            <Flex align="center" justify="center" vertical  style={{minHeight:"100vh"}}>
            <Logo />
            {children}
            </Flex>
    );
};

export default AuthContainer;
